<template>
  <div class="infinite">
    <div class="inner">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: "infiniteScroll",
  data() {
    return {
    //   innerHeight,
      defelate: true,
      timer: null,
    };
  },
  methods: {
    setTimeout() {
      // const { bottom } = this.$refs.container.getBoundingClientRect();
     let windowHeight = document.documentElement.clientHeight || document.body.clientHeight
    let scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop + windowHeight >= scrollHeight) {
        if (this.timer) {
          clearTimeout(this.timer);
        } 
          this.timer = setTimeout(()=>{
               this.timer = null;
              this.initScroll()}
              ,300);
      }
    },
    initScroll() {

        this.$emit("loadBottom",this.defelate)
    },
  },
  mounted() {
    window.addEventListener("scroll", this.setTimeout);
  },
};
</script>
<style lang="scss" scoped>
.infinite {
  width: 100%;
  // background-color: skyblue;
  overflow: auto;
  -webkit-overflow-scrolling: touch; // 解决iOS滚动问题
}
</style>